import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { SessionService } from '../../common/modules/user/services/SessionService';
import { UserService } from '../../common/modules/user/services/UserService'
import { User } from '../../common/modules/user/models/User';
import '../../styles.sass';

@Component({
	selector: 	'my-app',
	template: 	require('./AppComponent.html'),
	styles: [require('./AppComponent.sass')]
})

export class AppComponent {
	private module: string;
	private hostName: string;
    userData: User;
    message:        string;
    messageType:    string;
	
	constructor(
		private router: Router,
		private userService: UserService,
		private sessionService: SessionService,
		) {
		this.module = 'bus-parent-sidebar';
	}

	ngOnInit() {
		this.getSession();
		this.hostName = window.location.hostname;
	}
	
	private getSession() {
        this.sessionService.getSession()
            .subscribe(
                user => {
                    this.userService.setUserSessionData(user);
                    this.userService.userDataChanged(user);
					this.userData = user

                },
                error => {
                    //TO DO: Handle any error if needed in the furture
                    this.message     = "";
                    this.messageType = "alert";
					this.redirectLogin();
				}
            );
    } 

	redirectLogin() {
		return window.location.href = window.location.origin.replace('bus', 'services');
	}
}


// WEBPACK FOOTER //
// ./src/bus/parent/AppComponent.ts